import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAccountOperation from "./AbstractAccountOperation.js";

/**
 * Closing balance sums all transactions up to the end of the context period included.
 */
export default class ClosingBalanceAccountOperation extends AbstractAccountOperation {
	getName() {
		return _("Closing Balance");
	}

	getShortName() {
		return _("CB");
	}

	static getType() {
		return "ClosingBalanceAccountOperation";
	}

	static getOperationType() {
		return "ClosingBalance";
	}
}
